export enum CourseParam {
  Active = 'active',
  Completed = 'completed'
}

export enum CourseStatus {
  Passed = 'PASSED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotAvailable = 'NOT_AVAILABLE'
}

export interface ICourse {
  courseId: string;
  title: string;
  author: string;
  score: number;
  isNew: boolean;
  courseUrl: string | null;
  status: CourseStatus | null;
  coverPictureUrl: string | null;
  src?: string;
  isMultiLanguage?: boolean | null;
}

export interface ICoursesCounters {
  active: number;
  completed: number;
  all: number;
}

export interface ICourseOptions {
  filter?: CourseParam;
  skip?: number;
  limit?: number;
  search?: string;
  isNewSet?: boolean;
  sort?: string;
}

export interface ICourseTabMenu {
  key: CourseParam;
  counter: number;
  text: string;
}

export interface IUser extends IProfileMeta {
  id: string;
  email: string;
  avatarUrl?: string;
}

export interface IProfileMeta {
  name: string;
  country?: string;
  city?: string;
}

export interface IDropdownItem {
  key: string;
  label: string;
  iconChar?: string;
}
